import { LocationDescriptor } from 'history';
import { MentalLinkIdentifier, Identifier, LessonLinkIdentifier } from '../types';

/* eslint-disable class-methods-use-this */

class LinkManager {
    getHomeLink(): string {
        return 'https://elemental-app.com/';
    }

    getAboLink(): string {
        return 'https://elemental-app.com/abo-plan/';
    }

    getLoginLink(): string {
        return 'https://elemental-app.com/anmelden/';
    }

    getUserProfileLink(): LocationDescriptor {
        return 'https://elemental-app.com/account/';
    }

    getMenuLink(): LocationDescriptor {
        return '/menu';
    }

    getMentalIndexLink(): LocationDescriptor {
        return '/';
    }

    getFavoritesLink(): LocationDescriptor {
        return '/favoriten';
    }

    private getMentalBaseLink({ mentalId, mentalSlug }: MentalLinkIdentifier) {
        return `/mental/${mentalId}/${mentalSlug}/`;
    }

    getMentalLessonIndexLink(mentalLinkIdentifier: MentalLinkIdentifier): string {
        return `${this.getMentalBaseLink(mentalLinkIdentifier)}`;
    }

    getMentalLessonInfoLink({ mentalId, mentalSlug }: MentalLinkIdentifier): string {
        return `/info/${mentalId}/${mentalSlug}/`;
    }

    getMultipartLessonIndexLink(
        lessonLinkIdentifier: LessonLinkIdentifier,
    ): LocationDescriptor {
        return `${this.getMentalBaseLink(lessonLinkIdentifier.mental)}uebung-auswahl/${lessonLinkIdentifier.lessonId}/${lessonLinkIdentifier.lessonSlug}`;
    }

    getSingleLessonLink(
        mentalLinkIdentifier: MentalLinkIdentifier,
        lessonId: Identifier,
        lessonSlug: string,
    ): string {
        return `${this.getMentalBaseLink(mentalLinkIdentifier)}uebung/${lessonId}/${lessonSlug}`;
    }

    getMultipartLessonSingleLessonLink(
        mentalLinkIdentifier: MentalLinkIdentifier,
        parentLessonId: Identifier,
        parentLessonSlug: string,
        lessonId: Identifier,
        lessonSlug: string,
    ): string {
        return `${this.getMentalBaseLink(mentalLinkIdentifier)}uebung/${parentLessonId}/${parentLessonSlug}/${lessonId}/${lessonSlug}`;
    }

    getKnowHowIndexLink(mentalLinkIdentifier: MentalLinkIdentifier): LocationDescriptor {
        return `${this.getMentalBaseLink(mentalLinkIdentifier)}know-how`;
    }

    getKnowHowTextLink(
        mentalLinkIdentifier: MentalLinkIdentifier,
        knowHowTextIndex: Identifier,
        knowHowTextSlug: string,
    ): LocationDescriptor {
        return `${this.getMentalBaseLink(mentalLinkIdentifier)}know-how/${knowHowTextIndex}/${knowHowTextSlug}`;
    }

    isExternalLink(link: LocationDescriptor): boolean {
        if (typeof link !== 'string') return false;

        const toLc = link.toLowerCase();

        return toLc.startsWith('http://')
            || toLc.startsWith('https://');
    }
}

export default new LinkManager();
